'use client'

import { Heart, Target, Users, Sparkles } from 'lucide-react'
import { FadeUp } from '@/components/ui/fade-up'

const values = [
    {
        icon: Heart,
        title: '誠実であれ',
        subtitle: 'Be Sincere',
        description: '顧客と社会に対し、常に誠実であることを約束します。美談や偽りに頼らず、真実の価値を追求します。'
    },
    {
        icon: Target,
        title: '主権を尊べ',
        subtitle: 'Respect Sovereignty',
        description: '安易な依存を良しとせず、自らの手で未来を創り出す「独立した航海者」です。パートナーの皆様が「デジタル主権」を確立することを支援します。'
    },
    {
        icon: Heart,
        title: '深い敬意を払え',
        subtitle: 'Show Deep Respect',
        description: '私たちの仕事は、敬意から始まります。地域と企業の文化、そしてそこにいる人々への深い敬意なくして、真の価値創造はありえません。'
    },
    {
        icon: Users,
        title: '共助を力とせよ',
        subtitle: 'Find Strength in Co-creation',
        description: '地域全体の成功こそが、自らの成功だと信じます。競争ではなく「共創」を、独占ではなく「共助」を、私たちの行動の中心に置きます。'
    },
    {
        icon: Sparkles,
        title: '熱狂を生み出せ',
        subtitle: 'Create Passion',
        description: '単なる効率化された未来ではなく、人々が「ここで挑戦したい」と心から思える、熱狂と希望に満ちた未来を創造します。'
    }
]

export function ValuesSection() {
    return (
        <section className="py-16 md:py-24 bg-[#BEB0A8]">
            <div className="container px-4">
                <div className="max-w-5xl mx-auto space-y-16 mb-12 md:mb-16">
                    <FadeUp className="text-center">
                        <h2 className="font-['Montserrat',_sans-serif] text-[16px] md:text-[18px] font-semibold text-[#292623]/60 mb-4 tracking-wider">MISSION</h2>
                        <p className="font-['Shippori_Mincho_B1',_serif] text-[24px] md:text-[40px] text-[#292623] leading-relaxed font-bold tracking-wide">
                            デジタルの力で、地域の誇りを、<br className="hidden md:block" />未来の価値に。
                        </p>
                    </FadeUp>

                    <FadeUp className="text-center" delay={0.2}>
                        <h2 className="font-['Montserrat',_sans-serif] text-[16px] md:text-[18px] font-semibold text-[#292623]/60 mb-4 tracking-wider">VISION</h2>
                        <p className="font-['Shippori_Mincho_B1',_serif] text-[24px] md:text-[40px] text-[#292623] leading-relaxed font-bold tracking-wide">
                            すべての地域が、その文化と誇りに、<br className="hidden md:block" />経済的な価値を見出す社会。
                        </p>
                    </FadeUp>
                </div>

                {/* バリュー */}
                <FadeUp className="text-center mb-12 md:mb-16">
                    <h2 className="font-['Montserrat',_sans-serif] text-[16px] md:text-[18px] font-semibold text-[#292623]/60 mb-4 tracking-wider">VALUES</h2>
                    <p className="font-['Noto_Sans_JP',_sans-serif] text-[18px] md:text-[24px] text-[#292623] font-medium">
                        私たちが約束する行動指針
                    </p>
                </FadeUp>

                <div className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {values.map((value, index) => {
                        const Icon = value.icon
                        return (
                            <FadeUp key={index} delay={index * 0.1}>
                                <div className="h-full p-6 bg-white/80 backdrop-blur rounded-lg border border-[#292623]/10">
                                    <Icon className="h-10 w-10 text-[#292623] mb-4" />
                                    <h3 className="font-['Noto_Sans_JP',_sans-serif] text-[18px] md:text-[20px] text-[#292623] font-bold mb-2">{value.title}</h3>
                                    <p className="font-['Montserrat',_sans-serif] text-[12px] text-[#292623]/50 mb-4 italic tracking-wide">{value.subtitle}</p>
                                    <p className="font-['Noto_Sans_JP',_sans-serif] text-[13px] md:text-[14px] text-[#292623]/70 leading-relaxed">{value.description}</p>
                                </div>
                            </FadeUp>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}
